import { Tooltip, IconButton, BoxProps } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface IRemoveItem extends BoxProps {
  onClick?: () => void;
  label?: string;
  icon?: IconProp;
  size?: string;
  colorScheme?: string;
  variant?: string;
  'data-selector'?: string;
}

const RemoveItem = (props: IRemoveItem) => {
  const {
    label = 'Remove',
    icon = faTimesCircle,
    onClick,
    size = 'lg',
    colorScheme = 'red',
    variant = 'secondary',
  } = props;

  return (
    <Tooltip hasArrow label={label} placement="top">
      <IconButton
        data-selector={props['data-selector']}
        aria-label={label}
        onClick={onClick}
        icon={<FontAwesomeIcon icon={icon} />}
        variant={variant}
        size={size}
        colorScheme={colorScheme}
      />
    </Tooltip>
  );
};

export { RemoveItem };
